import type { Language } from '@/api/v1/administration/profile/update-language/update-language.types'
import { fetchBlobFromApi } from '@/lib/document-download/document-download'

export async function downloadAnchorReceipt(
  envelopeId: string,
  fileName: string,
  language: Language,
) {
  const blob = await fetchBlobFromApi(
    `/v1/ecm/envelopes/${envelopeId}/anchors/receipt?language=${language}`,
  )
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  anchor.click()
  URL.revokeObjectURL(url)
}
